import React, { useContext, useState, useEffect } from 'react';

import SideInfo from '../../Components/sideInfo';
import DashBoardSideBar from '../../Components/dashboard/sidebar';
import UserBuilds from '../../Components/dashboard/userBuilds';
import DashboardHeader from '../template/header/dashboardHeader';
import LoadingAnimation from '../../Components/loadingAnimation';
import { getUserFromLocalStorage } from '../../utils/localStorage';
import { useNavigate } from 'react-router-dom';
import { AppConfigContext } from '../../Config/App';

const Dashboard = ({classes}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const { navigate_to } = useContext(AppConfigContext);
    const user_session = getUserFromLocalStorage();
    const navigate = useNavigate();

    useEffect(() => {
        if (!user_session) {
            navigate(navigate_to('auth'));
        } else {
            setIsLoaded(true);
        }
        // eslint-disable-next-line
    }, []);

    if (!isLoaded) {
        return <LoadingAnimation />
    } else {
        return (
            <div className={classes}>
                <DashboardHeader />
                <SideInfo classes="d-lg-block col-12 col-lg-3 me-3 dashboard-bk">
                    <DashBoardSideBar />
                </SideInfo>
                <UserBuilds />
            </div>
        )
    }
}
export default Dashboard;